import React from 'react';
import {Dropdown} from 'wix-ui-core/dropdown';
import {Option} from 'wix-ui-core/dropdown-option';
import st from './Sort.st.css';
import s from './Sort.scss';
import {Accept, ArrowDown} from '../../../icons/dist';
import {sortOptions} from '../../../constants';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../galleryGlobalStrategy';

@withGlobals
@withTranslations()
export class Sort extends React.Component<IGalleryGlobalProps & IProvidedTranslationProps> {
  private readonly getOptions = () => {
    const {selectedSort, sortingOptions} = this.props.globals;
    return sortingOptions.map(o => ({
      isDisabled: false,
      isSelectable: true,
      id: o.id,
      value: this.getOptionText(o),
      render: value => (
        <div tabIndex={0} className={s.selectorItem}>
          <span>{value}</span>
          {selectedSort.id === o.id && <Accept data-hook="selected-option-icon" />}
        </div>
      ),
    }));
  };

  private readonly getOptionText = o => {
    return this.props.t(o.titleKey);
  };

  private readonly onSelect = (option: Option) => {
    if (!option) {
      return;
    } //fix for when `option` is null. Might be fixed in the future, then this line can be removed: https://github.com/wix/wix-ui/issues/1016
    this.setState({selected: option.id});
    const sortingOption = sortOptions.find(o => o.id === option.id);
    this.props.globals.sortProducts(sortingOption);
  };

  public render = () => {
    const {selectedSort} = this.props.globals;
    return (
      <div {...st('root')}>
        <Dropdown
          {...st('dropdown')}
          openTrigger={'click'}
          initialSelectedIds={['default']}
          onSelect={this.onSelect}
          options={this.getOptions()}>
          <button className={s.selector} data-hook="select-button">
            <span className={s.selectorText}>
              {this.getOptionText(sortOptions.find(o => o.id === selectedSort.id))}
            </span>
            <span>
              <ArrowDown />
            </span>
          </button>
        </Dropdown>
      </div>
    );
  };
}
